module.exports = __webpack_public_path__ + "img/node.1126fca3.svg";